import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DetailVpsUsComponent from "../../../components/Customer/vps_us/DetailVpsUsComponent";

const DetailVpsUsPage = () => {
    const params = useParams();
    const navigate = useNavigate();

    let redirectBack = () => {
        navigate(-1);
    }

    return <DetailVpsUsComponent
        vpsId={ params.vpsId }
        redirectBack={ () => redirectBack() }
    />;
}

export default DetailVpsUsPage;